import React, { memo } from 'react';

import { sortObjByField } from '../../../service/sort';
import { DocumentItem } from '../../DocumentsPage/DocumentItem/DocumentItem';
import { DocumentPrefix } from '../../../service/constants';
import { useDefects } from '../../../selectors/defects';
import { useStyles } from './useStyles';

export const Limitations = memo(() => {
    const defects = useDefects();
    const classes = useStyles();

    return (
        <>
            {defects.sort(sortObjByField('name')).map(({ id, name }) => (
                <DocumentItem key={id} id={`${DocumentPrefix.DEFECT}${id}`} primaryText={name} className={classes.nested} />
            ))}
        </>
    );
});

Limitations.displayName = 'Limitations';
